import React, { useEffect, useState } from "react";
import ProductItem from "./ProductItem.jsx";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Box, CircularProgress } from "@mui/material";

const HotProduct = () => {
  const navigate = useNavigate();

  const [activeId, setActiveId] = useState();
  const [products, setProducts] = useState([]);
  const [data, setData] = useState([]);
  const [titleViewMore, setTitleViewMore] = useState("");
  const [slugviewMore, setSlugViewMore] = useState("");
  const [loading, setLoading] = useState(false);

  const handleClick = (id) => {
    setActiveId(id === activeId ? null : id);
  };

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    axios
      .get(`/api/v1/categories/hot`)
      .then((res) => {
        setData(res.data);
        setActiveId(res.data[0].id);
        setTitleViewMore(res.data[0].name);
        setSlugViewMore(res.data[0].slug);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    setLoading(true);
    if (activeId) {
      getProductByTag(activeId);
    }
  }, [activeId]);

  const getProductByTag = (id) => {
    axios
      .get(`/api/v1/products`, {
        params: {
          categoryId: activeId,
          limit: 8,
          page: 1
        },
      })
      .then((res) => {
        setProducts(res.data.products);
        setLoading(false);
      })
      .catch((err) => console.log(err));
  };

  return (
    <div className="hot-product-container">
      <div className="hot-product-title">
        <div className="hot-product-title-text">
          <i className="bi bi-heart me-2"></i>Danh Mục Sản Phẩm HOT
        </div>
      </div>
      <div className="hot-product-tag">
        {data.map((item, idx) => (
          <div
            key={idx}
            className={`hot-product-tag-text ${
              activeId === item.id ? "active" : ""
            }`}
            onClick={() => {
              handleClick(item.id);
              setTitleViewMore(item.name);
              setSlugViewMore(item.slug);
              setProducts([]);
            }}
          >
            {item.name}
          </div>
        ))}
      </div>
      <div className="hot-product-content">
        {products.map((item, idx) => (
          <ProductItem data={item} key={idx} />
        ))}
      </div>
      {loading && (
        <Box sx={{ textAlign: "center", width: "100%" }}>
          <CircularProgress sx={{ color: "#0184b7" }} />
        </Box>
      )}
      <div
        className="hot-product-view-more mt-4"
        onClick={() => navigate(slugviewMore)}
      >
        <p>Xem Thêm {titleViewMore}</p>
        <div className="line"></div>
      </div>
    </div>
  );
};

export default HotProduct;
